<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg168"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs172"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath182"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path180" /></clipPath><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath226"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path224" /></clipPath><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath284"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path282" /></clipPath></defs><g
     id="g174"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g176"><g
         id="g178"
         clip-path="url(#clipPath182)"><path
           d="M 504.5,181 H 7.5 v 300 h 497 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path184" /></g></g><g
       id="g186"
       transform="translate(37.5,451)"><path
         d="M 0,0 H 437"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path188" /></g><g
       id="g190"
       transform="translate(37.5,271)"><path
         d="M 0,0 V 210"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path192" /></g><g
       id="g194"
       transform="translate(37.5,181)"><path
         d="M 0,0 V 60 H 437"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path196" /></g><g
       id="g198"
       transform="translate(474.5,481)"><path
         d="M 0,0 V -300"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path200" /></g><path
       d="m 67.5,271 h 51.4 V 421 H 67.5 Z"
       style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
       id="path202" /><path
       d="m 148.9,271 h 51.4 v 150 h -51.4 z"
       style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
       id="path204" /><path
       d="m 230.3,271 h 51.4 v 150 h -51.4 z"
       style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
       id="path206" /><path
       d="m 311.7,271 h 51.4 v 150 h -51.4 z"
       style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
       id="path208" /><path
       d="m 393.1,271 h 51.4 v 150 h -51.4 z"
       style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
       id="path210" /><g
       id="g212"
       transform="translate(133.8999,181)"><path
         d="M 0,0 V 30 H 81.4 V 0"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path214" /></g><g
       id="g216"
       transform="translate(296.7002,181)"><path
         d="M 0,0 V 30 H 81.4 V 0"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path218" /></g><g
       id="g220"><g
         id="g222"
         clip-path="url(#clipPath226)"><path
           d="m 7.5,31 h 497 V 151 H 7.5 Z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path228" /><g
           id="g230"
           transform="translate(504.5,61)"><path
             d="M 0,0 H -497"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path232" /></g></g></g><g
       id="g234"
       transform="translate(106,106)"><path
         d="M 0,0 V 45"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path236" /></g><g
       id="g238"
       transform="translate(136,121)"><path
         d="M 0,0 V 30"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path240" /></g><g
       id="g242"
       transform="translate(166,106)"><path
         d="M 0,0 V 45"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path244" /></g><g
       id="g246"
       transform="translate(406,106)"><path
         d="M 0,0 V 45"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path248" /></g><g
       id="g250"
       transform="translate(376,121)"><path
         d="M 0,0 V 30"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path252" /></g><g
       id="g254"
       transform="translate(316,121)"><path
         d="M 0,0 V 30"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path256" /></g><g
       id="g258"
       transform="translate(286,106)"><path
         d="M 0,0 V 45"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path260" /></g><g
       id="g262"
       transform="translate(226,106)"><path
         d="M 0,0 V 45"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path264" /></g><g
       id="g266"
       transform="translate(196,121)"><path
         d="M 0,0 V 30"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path268" /></g><g
       id="g270"
       transform="translate(346,106)"><path
         d="M 0,0 V 45"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path272" /></g><g
       id="g274"
       transform="translate(256,121)"><path
         d="M 0,0 V 30"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path276" /></g><g
       id="g278"><g
         id="g280"
         clip-path="url(#clipPath284)"><g
           id="g286"
           transform="translate(67.5,106)"><path
             d="m 0,0 c 0,8.284 -6.716,15 -15,15 -8.284,0 -15,-6.716 -15,-15 0,-8.284 6.716,-15 15,-15 8.284,0 15,6.716 15,15 z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path288" /></g><g
           id="g290"
           transform="translate(474.5,106)"><path
             d="m 0,0 c 0,8.284 -6.716,15 -15,15 -8.284,0 -15,-6.716 -15,-15 0,-8.284 6.716,-15 15,-15 8.284,0 15,6.716 15,15 z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path292" /></g></g></g></g></svg>
</template>
